var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSsnCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "45px",
    viewBox: "0 0 70 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Visacard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-548.000000, -127.000000)",
    stroke: "#043F93",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visacard",
    transform: "translate(583.000000, 149.500000) scale(1, -1) translate(-583.000000, -149.500000) translate(548.000000, 127.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-1510",
    x: 1,
    y: 1,
    width: 68,
    height: 43,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25,24.25 L16.25,24.25",
    id: "Line",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25,18 L22.5,18",
    id: "Line",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5,18 L30,18",
    id: "Line",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25,24.25 L31.25,24.25",
    id: "Line",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.25,24.25 L46.25,24.25",
    id: "Line",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.25,24.25 L61.25,24.25",
    id: "Line",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsnCard);
export default __webpack_public_path__ + "static/media/SSNCard.8fd35a869ec33f96123ab099213d4626.svg";
export { ForwardRef as ReactComponent };